import { gql } from 'graphql-tag';

export const REFERRAL_CODE = gql`
  query marketingReferralFromSessionAndValidate {
    marketingReferralFromSessionAndValidate {
      referralCode
      referrerName
      referralValue
      isValid
      message
    }
  }
`;
